import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6">
      <div className="max-w-lg text-center">
        <h1 className="text-5xl font-bold font-poppins text-[#1A1A1A]">404</h1>
        <h2 className="mt-3 text-2xl font-semibold text-[#1A1A1A]">Page not found</h2>
        <p className="mt-3 text-[#555555]">
          The page you requested does not exist or may have moved.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-[#121212] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#2A2A2A] transition-colors"
          >
            Go to dashboard
          </Link>
          <Link
            to="/library"
            className="inline-flex items-center justify-center rounded-md border border-[#DADADA] bg-white px-5 py-2.5 text-sm font-medium text-[#1A1A1A] hover:bg-[#FAFAFA] transition-colors"
          >
            Browse training library
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
